const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const formatFileSize = (bytes) => {
	const size = Number(bytes);
	if (!Number.isFinite(size) || size < 0) return "0 B";
	if (size < 1024) return `${size} B`;
	if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
	return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

export const isCsvFile = (file) => {
	if (!file) return false;
	const name = String(file.name || "").toLowerCase();
	return name.endsWith(".csv");
};

export const countCsvDataRows = (fileContent) => {
	const lines = String(fileContent || "")
		.replace(/^\uFEFF/, "")
		.split(/\r?\n/)
		.map((line) => line.trim())
		.filter(Boolean);

	if (lines.length < 2) {
		throw new Error("CSV must include a header row and at least one data row.");
	}

	return lines.length - 1;
};

export const validateEhrCsvFile = async (file) => {
	if (!file) {
		return { error: "Please select a CSV file.", isValid: false };
	}

	if (!isCsvFile(file)) {
		return { error: "Only .csv files are accepted.", isValid: false };
	}

	if (file.size > MAX_FILE_SIZE_BYTES) {
		return { error: "File exceeds the 10MB limit.", isValid: false };
	}

	if (file.size === 0) {
		return { error: "The selected file is empty.", isValid: false };
	}

	let fileContent = "";
	try {
		fileContent = await file.text();
	} catch {
		return { error: "The selected file could not be read.", isValid: false };
	}

	if (!String(fileContent || "").trim()) {
		return { error: "The selected file is empty.", isValid: false };
	}

	try {
		const rowCount = countCsvDataRows(fileContent);
		if (rowCount === 0) {
			return {
				error: "No data rows were detected. The CSV must include at least one row after the header.",
				isValid: false,
			};
		}

		return {
			fileContent,
			isValid: true,
			rowCount,
			status: "Ready",
		};
	} catch (error) {
		return {
			error: error.message || "The selected file could not be parsed.",
			isValid: false,
		};
	}
};

export { MAX_FILE_SIZE_BYTES };
